import styled from "@emotion/styled";
import {
    boxSizes,
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
} from "../base/theme";
import Dialog from "../dialog/dialog";
import Button from "../button/button";

export const StyledDialog = styled(Dialog)`
    border-radius: ${boxSizes.borderRadius8};
    padding: 0;
    width: 418px;

    ${mediaQuery.until(breakpoints.small)} {
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        border-radius: ${gutterSizes.base} ${gutterSizes.base} 0 0;
        max-height: 90%;
    }

    .dialog-content {
        padding: ${gutterSizes.large40} ${gutterSizes.xlarge} ${gutterSizes.xxlarge};
    }

    .dialog-close .icon.icon--clear {
        font-size: ${fontSizes.small14};
        color: ${colors.bark};
    }

    h2 {
        font-weight: ${fontWeights.bold};
        font-size: ${fontSizes.xlarge};
        line-height: ${lineHeights.large};
        margin-bottom: ${gutterSizes.base};
    }

    p {
        margin: 0;
    }
`;

export const LearnMoreButton = styled(Button)`
    height: auto;
    font-weight: ${fontWeights.bold};
    color: ${colors.blade};
    font-size: ${fontSizes.base};
    line-height: 24px;
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0px;
    margin-top: ${gutterSizes.base};
`;
